import { Link } from "../link.model"
import { ITSImage } from "../itsImage.model"

export class PremiumFooterSection {
    public constructor(
        public title: string,
        public description: string,
        public image: ITSImage,
        public links: Link[],
        public showOnHomepage: boolean
    ) {}

    public static fromData(data): PremiumFooterSection {
        return new PremiumFooterSection(
            data.title,
            data.description,
            new ITSImage(data.image, ""),
            (data.links || []).map((link_data) => new Link(link_data.text, link_data.url)),
            data.show_on_homepage
        )
    }
}
